import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export class ApActivationCodeValidator {
    public static validate(control: AbstractControl): ValidationErrors {
        return Validators.compose([Validators.pattern(/^\d*$/i), Validators.minLength(6), Validators.maxLength(6)])(control);
    }
}
